<div *ngIf="(fundraiser?.banktransfer?.info_3 || fundraiser?.settings?.show_qr)" class="dm-container">
  <span class="dm-headr main-headr">Other Donation Methods</span>
  <div class="dm-line"></div>
  <div>
    <!-- Bank transfer -->
    <!-- <ng-template [ngTemplateOutlet]="bankCard"></ng-template> -->
    <!-- UPI donations -->
    <ng-template [ngTemplateOutlet]="upiCard"></ng-template>
  </div>
</div>


<ng-template #bankCard>
  <div #bankRef *ngIf="fundraiser?.banktransfer?.info_3" class="bank-container">
    <app-fr-card>
      <mat-card-header class="b-header-margin">
        <div *ngIf="isMobile">
          <mat-icon class="b-icon icon-bank"></mat-icon>
        </div>
        <div class="b-header">{{ 'Stories.bankTransfer.transferToDescription' | translatePipe | async }}</div>
        <!-- <div class="b-header" *ngIf="!isMobile">
          You can also directly transfer to the below mentioned account of this fundraiser:
        </div> -->
      </mat-card-header>
      <mat-card-content class="b-content">
        <div class="b-details">
          <div mat-card-avatar *ngIf="!isMobile">
            <mat-icon class="b-icon icon-bank"></mat-icon>
          </div>
          <div>
            <div class="b-item">
              <div class="b-heading">{{ 'Stories.bankTransfer.virtualAccNo' | translatePipe | async }}</div><span class="b-colon">:</span>
              <div class="b-label">{{bankInfo?.account_number}}</div>
            </div>
            <div class="b-item">
              <div class="b-heading">{{ 'Stories.bankTransfer.virtualAccName' | translatePipe | async }}</div><span class="b-colon">:</span>
              <div class="b-label">{{bankInfo?.name}}</div>
            </div>
            <div class="b-item">
              <div class="b-heading">{{ 'Stories.bankTransfer.accountType' | translatePipe | async }}</div><span class="b-colon">:</span>
              <div class="b-label">{{ 'Stories.bankTransfer.current' | translatePipe | async }}</div>
            </div>
            <div class="b-item">
              <div class="b-heading">{{ 'Stories.bankTransfer.ifsc' | translatePipe | async }}</div><span class="b-colon">:</span>
              <div class="b-label">{{bankInfo?.ifcs}}</div>
            </div>
            <div class="b-item">
              (The Digit after N is zero)
            </div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-footer class="b-footer" data-bg="../assets/images/upi-card-bg.png">
        <span>
          {{ 'Stories.upiPayment.donationClaimAck1' | translatePipe | async }} <a class="url" (click)="openDialog(payment_option.bank)">{{ 'Stories.bankTransfer.bankTransfer' | translatePipe | async }} </a> {{ 'Stories.upiPayment.donationClaimAck2' | translatePipe | async }}
        </span>
      </mat-card-footer>
    </app-fr-card>
  </div>
</ng-template>

<ng-template #upiCard>
  <div #upiRef *ngIf="fundraiser?.settings?.show_qr" class="donation-container">
    <app-fr-card *ngIf="isMobile">
      <div class="dm-header-container">
        <div class="dm-headr headertxt">Donate via</div>
        <div class="dm-option-conatiner">
          <div class="credit-debit" data-bg="../assets/images/payment-opt1.svg"></div>
          <div class="netbank" data-bg="../assets/images/payment-opt1.svg "></div>
        </div>
      </div>
      <mat-card-content class="donation-content">
        <app-donate-now [label]="donateBtnLabel" [icon]="false" [fundraiser]="fundraiser" [position]="10" [tagLabel]="tagLabel" [theme]="theme" [recommendTag]="recommendTag">
        </app-donate-now>
        <div class="or">
          <div class="or-line"></div>
          <span class="or-label">OR</span>
          <div class="or-line"></div>
        </div>
        <div class="dm-headr headertxt ml-4">Donate via UPI or Paytm</div>
        <app-upi-icons [origin]="origin" [userdata]="userdata" [tagLabel]="tagLabel" [theme]="theme" [recommendTag]="recommendTag"></app-upi-icons>
      </mat-card-content>
      <mat-card-footer class="b-footer">
        <span>
            {{ 'Stories.upiPayment.donationClaimAck1' | translatePipe | async }} <a class="url" (click)="openDialog(payment_option.paytm)">Paytm</a> and <a class="url" (click)="openDialog(payment_option.upi)">UPI</a> {{'Stories.upiPayment.donationClaimAck2' | translatePipe | async }}
        </span>
      </mat-card-footer>
    </app-fr-card>

    <div *ngIf="!isMobile && showQR">
      <div class="desktop-qr-code">
        <h1>{{ 'Stories.upiPayment.upiOptionTitle' | translatePipe | async }}</h1>
        <p class="qr-desc">{{ 'Stories.upiPayment.qrCodeTitle' | translatePipe | async }}</p>
        <div class="row" *ngIf="!isLoading">
          <div class="col-6">
            <span class="for-heading">{{ 'Stories.upiPayment.forPatym' | translatePipe | async }}</span>
            <!-- Razor Pay QR code -->
            <div class="upi-card upi-card2">
              <img class="qr-img" src="/assets/images/story/qr_sample.png" alt="Paytm QR Code" width="110" />
              <div class="title">{{ 'Stories.upiPayment.paytmWalletPayScanTitle' | translatePipe | async }}</div>
              <div class="qr-donat-now">
                <app-donate-now [isQR]="{name: 'Paytm', route: 'p'}" [tagLabel]="tagLabel" [theme]="theme" [recommendTag]="recommendTag"
                                [label]="'Stories.upiPayment.genQr' | translatePipe | async " [icon]="false" [fundraiser]="fundraiser" [position]="15">
                </app-donate-now>
              </div>
            </div>
          </div>
          <div class="col-6">
            <span class="for-heading">{{ 'Stories.upiPayment.forOtherApps' | translatePipe | async }}</span>
            <!-- Razor Pay QR code -->
            <div class="upi-card upi-card2 other-upis">
              <img id="benow" src="/assets/images/story/upi_qr_sample_1.png" alt="UPI QR Code" />
              <div class="qr-donat-now">
                <app-donate-now [isQR]="{name: 'UPI', route: 'u'}" [tagLabel]="tagLabel" [theme]="theme" [recommendTag]="recommendTag"
                                [label]="'Stories.upiPayment.genQr' | translatePipe | async" [icon]="false" [fundraiser]="fundraiser" [position]="15">
                </app-donate-now>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer" data-bg="../assets/images/upi-card-bg.png?w=auto">
        <span>
          {{ 'Stories.upiPayment.donationClaimAck1' | translatePipe | async }} <a class="url" (click)="openDialog(payment_option.paytm)">{{ 'Stories.upiPayment.paytm' | translatePipe | async }}</a> and <a class="url" (click)="openDialog(payment_option.upi)">UPI</a> {{'Stories.upiPayment.donationClaimAck2' | translatePipe | async }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
